export default {
  main: {
    site_id: 656,
    enableWorldCup: true,
    title: "Olybet Estonia PRO",
    staffPassword: "124578",
     enableWinterMode: false,
    enableKeyboardCatching: true,
    enableTouchToClick: true,
    hotjarId: 3930207,
    // yandexMetricaId: 96937549,
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    homeBannerSlides: [
      {
        fileType: 'jpg',
        path: "/betting/prematch",
      },
    ],
    ticketAvailableViewMode: ["card"],
    enableTicketPopupFlow: true,
    alwaysShowCheckTicket: true,
    enableTicketTimer: true,
    enableTicketAutoCashoutAmountUpdate: true,
    enableTerminalBalancePolling: true,
    websitePasswordHash: "fba54c7384adadca21b7502c15be7390f09590c941b4c38f65cb023aee05c727",
    logoSize: "big",
    isAdminSettingsButton: true,
    useLoyalCardBarcode: true,
    availableLanguages: {
      "@replace": true,
      est: {
        short: "EE",
        name: "Est",
        region: "Estonia",
        order: 1,
      },
      rus: {
        short: "RU",
        name: "Rus",
        region: "Russia",
        order: 3,
      },
      eng: {
        short: "EN",
        name: "Eng",
        region: "UnitedKingdom",
        order: 2,
      },
    },
  },
  home: {
    topPagesPaths: [
      "betting/live",
      "betting/prematch",
      "betting/results",
    ],
  },
  homePagesUrl: [
    {
      id: 1,
      url: 'betting/live',
      icon: 'global-icon icon-circle icon-a',
      className: 'outline',
      name: 'Live',
    },
    {
      id: 1992,
      url: 'betting/prematch',
      className: 'prematch-section',
      name: 'Sports',
    },
    {
      id: 3,
      url: 'betting/results',
      className: 'results-section',
      name: 'Results',
    },
  ],
  adminPageButtons: [
    {
      name: "Application and terminal management",
      type: "applicationAndTerminal",
      enabled: true,
    },
    {
      name: "Tickets",
      type: "lastTicket",
      enabled: true,
    },
    {
      name: "Financial tracking",
      type: "financialTracking",
      enabled: true,
      hideOnRestrictMode: false,
    },
    {
      name: "Open last log file",
      type: "openLastLogFile",
      enabled: true,
      hideOnRestrictMode: true,
    },
    {
      name: "Lock",
      type: "lockAndUnlock",
      param: {
        type: "lock",
      },
      enabled: false,
    },
    {
      name: "Unlock",
      type: "lockAndUnlock",
      param: {
        type: "unlock",
      },
      enabled: false,
    },
    {
      name: "Devices",
      type: "devices",
      enabled: true,
      hideOnRestrictMode: true,
    },
    {
      name: "Foreign Pass TIckets",
      type: "foreignPassTickets",
      enabled: true,
      startupConfigName: "IsOneTimeLoginEnabled",
    },
  ],
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      url: 'betting/live/all',
      name: 'Live',
      type: 'live',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/live/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/live/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: 'betting/prematch/all',
      type: 'prematch',
      name: 'Sports',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: 'betting/results',
      name: 'Results',
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  terminal: {
    signInToAdmin: true,
  },
  env: {
    lang: "est",
  },

  betslip: {
    showBonusRulesHint: true,
    enableBookingId: true,
    enableExpressBonus: true,
    bookingBetBalanceMaxLimit: 9999999,
    defaultPriceChangeType: 'AlwaysAsk',
    bookBetButtonText: 'Bet at cashier',
    enableBookingBet: true,
    staticStakes: ["5", "10", "20", "50", "100", "500"],
    enableSuperbetToggle: false,
    betDetailsOrder: [
      "total_odd",
      "total_stake",
      "min_possible_win",
      "possible_win",
      "bonus",
      "tax_on_return_or_profit",
      "total_win",
    ],
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
    {
      name: "Paid tickets by this terminal",
      type: "paidtickets",
      hideOnRestrictMode: false,
    },
  ],
  betBuilder: {
    enableTaxOnStake: false, // only for now, remove after refactoring of bet builder betslip part
  },
  defaultTerminalParams: { pid: 56, tid: 13313, token: "hKTBHQ==", currency: "EUR" },

  sportsbook: {
    sportList: {
      enablePredefinedMultiples: true,
    },
  },
};
